import { GetVisitFormDataQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitFormData/getVisitFormDataQuery.type';
import { getVisitFormDataFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitFormData/getVisitFormDataQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVisitFormDataQueryOptions = (
  params: GetVisitFormDataQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getVisitFormDataQueryOptions', params],
    queryFn: () => getVisitFormDataFunction(params),
  });
};
